import _typeof from "@babel/runtime/helpers/typeof";
var STEP = 10;
export function applyFlexPassDiscount(basePrice, discountPercent) {
  if (discountPercent == null || discountPercent === 0) {
    return basePrice;
  }

  var raw = basePrice * (1 - discountPercent / 100);
  return Math.ceil(raw / STEP) * STEP;
}
export function readFlexPassDiscountPercent(response) {
  var _data;

  if (response == null || _typeof(response) !== 'object') {
    return null;
  }

  var percent = (_data = response.data) === null || _data === void 0 ? void 0 : _data.discountPercent;
  return typeof percent === 'number' ? percent : null;
}